import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Error404 from '../Pages/Error404';
import {
  CollegeHome,
  CollegeLogin,
  CollegePathway,
  Dashboard,
  ProgramMap,
  Profile,
  Validation,
  SingleFaculty,
  SingleFacultyNew,
  CoursesInCollege,
  EmailUpdate,
  StudentCourseVerificationNew,
  ViewStudents,
  StudentProfile,
  ExamVerification,
  PaymentResponse,
  PaymentSuccess,
  HallTicketDownload,
  QuestionPaperDownloadOTP,
  QuestionPaperDownloadPage,
  PaymentReceiptList,
  StudentCourseVerificationreview,
  StudentFeeDetails,
  ChangePasswordQuestionPaper,
  NominalRoll,
  Attendance,
  Internalmarkmapping,
  InternalMarkVerification,
  ExternalPracticalMarkList,
  ExternalTheoryMarkList,
  CCAMarkList,
  ChangePassword,
  TrView,
  StudentAppliedRevaluationList,
  CollegeStudentCOAttainment,
  CollegeStudentCOAttainmentProfile,
  CollegeStudentCOAttainmentSupply,
  CollegeStudentCOAttainmentProfileSupply,
  CollegeStudentCOAttainmentpdf,
  DownloadFacingSheet,
  StudentAnswerScriptList,
  CollegeBundleDespStatistics,
  TeacherSingatureCourse,
  SFAUserMappingLists,
  SFAUserMappingDetails,
  UsersInCollege,
  AddUsers,
  EditUsers,
  Bvoc_ProgramMap,
  StudentSupplyRegistration,
  SupplementaryAttendance,
  SupplementaryHallTicketDownload,
  SupplementaryNominalRoll,
  DownloadSupplementaryFacingSheet,
  Readmission,
  TrSupplyView,
  InternshipList,
  IMUUserMapping,
  IMUStudentMapping,
  PrincipalExternalCreditApplication,
  LateInternalMarkVerification,
  StudentInternshipApproval,
  StudentInternshipMark,
  IPOVendorlist

} from "../Pages/College";

import ProtectedRoute from '../component/ProtectedRoute';
import Condonation from '../Pages/College/Condonation';




const UserRoutes = () => (
  <Routes>
    <Route path="/*" element={<Error404 />} />
    <Route path="/" element={<CollegeLogin />} />
    <Route path="/validation" element={<Validation />} />
    <Route path="/collegedashboard" element={<ProtectedRoute element={<Dashboard />} role={2} />} />
    <Route path="/collegepathway" element={<ProtectedRoute element={<CollegePathway role={2} />} />} />
    <Route path="/collegehome" element={<ProtectedRoute element={<CollegeHome />} role={2} />} />
    <Route path="/programmapping" element={<ProtectedRoute element={<ProgramMap />} role={2} />} />
    <Route path="/profile" element={<ProtectedRoute element={<Profile />} role={2} />} />
    <Route path="/singlefaculty" element={<ProtectedRoute element={<SingleFaculty />} role={2} />} />
    <Route path="/coursesincollege" element={<ProtectedRoute element={<CoursesInCollege />} role={2} />} />
    <Route path="/singlefacultynew" element={<ProtectedRoute element={<SingleFacultyNew />} role={2} />} />
    <Route path="/emailupdate" element={<ProtectedRoute element={<EmailUpdate />} role={2} />} />
    <Route path="/studentcourseverificationnew" element={<ProtectedRoute element={<StudentCourseVerificationNew />} role={2} />} />
    <Route path="/studentcourseverification" element={<ProtectedRoute element={<StudentCourseVerificationreview />} role={2} />} />
    <Route path="/viewadmittedstudents" element={<ProtectedRoute element={<ViewStudents />} role={2} />} />
    <Route path="/studentprofile/:id" element={<ProtectedRoute element={<StudentProfile />} role={2} />} />
    <Route path="/examverification/" element={<ProtectedRoute element={<ExamVerification />} role={2} />} />
    <Route path="/paymentresponse/" element={<ProtectedRoute element={<PaymentResponse />} role={2} />} />
    <Route path="/paymentstatus/" element={<ProtectedRoute element={<PaymentSuccess />} role={2} />} />
    <Route path="/hallticketdownload/" element={<ProtectedRoute element={<HallTicketDownload />} role={2} />} />
    <Route path="/questionpaperdownloadotp/" element={<ProtectedRoute element={<QuestionPaperDownloadOTP />} role={2} />} />
    <Route path="/questionpaperdownloadpage/" element={<ProtectedRoute element={<QuestionPaperDownloadPage />} role={2} />} />
    <Route path="/paymentreceiptlist/" element={<ProtectedRoute element={<PaymentReceiptList />} role={2} />} />
    <Route path="/studentfeedetails/:eid/:tid" element={<ProtectedRoute element={<StudentFeeDetails />} role={2} />} />
    <Route path="/changepasswordquestionpaper/" element={<ProtectedRoute element={<ChangePasswordQuestionPaper />} role={2} />} />
    <Route path="/nominalroll/" element={<ProtectedRoute element={<NominalRoll />} role={2} />} />
    <Route path="/attendance/" element={<ProtectedRoute element={<Attendance />} role={2} />} />
    <Route path="/internalmapping/" element={<ProtectedRoute element={<Internalmarkmapping />} role={2} />} />
    <Route path="/verifyinternalmark/" element={<ProtectedRoute element={<InternalMarkVerification />} role={2} />} />
    <Route path="/extpracticalmark/" element={<ProtectedRoute element={<ExternalPracticalMarkList />} role={2} />} />
    <Route path="/exttheorymark/" element={<ProtectedRoute element={<ExternalTheoryMarkList />} role={2} />} />
    <Route path="/markdetails/" element={<ProtectedRoute element={<CCAMarkList />} role={2} />} />
    <Route path="/changepassword/" element={<ProtectedRoute element={<ChangePassword />} role={2} />} />
    <Route path="/trview/" element={<ProtectedRoute element={<TrView />} role={2} />} />
    <Route path="/trsupplyview/" element={<ProtectedRoute element={<TrSupplyView />} role={2} />} />
    <Route path="/studappdrevallist/" element={<ProtectedRoute element={<StudentAppliedRevaluationList />} role={2} />} />
    <Route path="/collegestudentcoattainment/" element={<ProtectedRoute element={<CollegeStudentCOAttainment />} role={2} />} />
    <Route path="/collegestudentcoattainmentpdf/" element={<ProtectedRoute element={<CollegeStudentCOAttainmentpdf />} role={2} />} />
    <Route path="/studentcoattainmentprofile/:eid/:acid" element={<ProtectedRoute element={<CollegeStudentCOAttainmentProfile />} role={2} />} />

    {/* Late Internal Mark Verification - new route added for late submission approval */}
    <Route path="/verifylateinternalmark/" element={<ProtectedRoute element={<LateInternalMarkVerification />} role={2} />} />


    <Route path="/collegestudentcoattainmentsupply/" element={<ProtectedRoute element={<CollegeStudentCOAttainmentSupply />} role={2} />} />
    <Route path="/collegestudentcoattainmentprofilesupply/:eid/:acid" element={<ProtectedRoute element={<CollegeStudentCOAttainmentProfileSupply />} role={2} />} />
    <Route path="/downloadfacingsheet/" element={<ProtectedRoute element={<DownloadFacingSheet />} role={2} />} />
    <Route path="/studentanswerscriptlist/" element={<ProtectedRoute element={<StudentAnswerScriptList />} role={2} />} />
    <Route path="/collegebundledespstat/" element={<ProtectedRoute element={<CollegeBundleDespStatistics />} role={2} />} />
    <Route path="/signaturecourse/" element={<ProtectedRoute element={<TeacherSingatureCourse />} role={2} />} />
    <Route path="/sfausermappinglists/" element={<ProtectedRoute element={<SFAUserMappingLists />} role={2} />} />
    <Route path="/sfausermappingdetails/:yearid/:semid/:discid/:disctype/:singlefaculty" element={<ProtectedRoute element={<SFAUserMappingDetails />} role={2} />} />
    <Route path="/usersincollege/" element={<ProtectedRoute element={<UsersInCollege />} role={2} />} />
    <Route path="/addusers/" element={<ProtectedRoute element={<AddUsers />} role={2} />} />

    <Route path="/editusers/:uid/" element={<ProtectedRoute element={<EditUsers />} role={2} />} />
    
    <Route path="/condonation" element={<ProtectedRoute element={<Condonation />} role={2} />} />
    <Route path="/supplyregister" element={<ProtectedRoute element={<StudentSupplyRegistration />} role={2} />} />
    <Route path="/readmission" element={<ProtectedRoute element={<Readmission />} role={2} />} />
    <Route path="/internshiplist" element={<ProtectedRoute element={<InternshipList />} role={2} />} />
    <Route path="/imuusermapping/" element={<ProtectedRoute element={<IMUUserMapping />} role={2} />} />
    <Route path="/imustudentmapping/" element={<ProtectedRoute element={<IMUStudentMapping />} role={2} />} />
    <Route path="/studentinternshipapproval/" element={<ProtectedRoute element={<StudentInternshipApproval />} role={2} />} />
    <Route path="/studentInternshipMark/" element={<ProtectedRoute element={<StudentInternshipMark />} role={2} />} />
    <Route path="/ipovendorlist/" element={<ProtectedRoute element={<IPOVendorlist />} role={2} />} />



   // BVOC
    <Route path="/bvocprogrammap" element={<ProtectedRoute element={<Bvoc_ProgramMap />} role={2} />} />


    {/* Supplementary Attendance */}
    <Route path="/supplementaryattendance/" element={<ProtectedRoute element={<SupplementaryAttendance />} role={2} />} />
    {/* Supplementary Hall Ticket Download */}
    <Route path="/supplementaryhallticket/" element={<ProtectedRoute element={<SupplementaryHallTicketDownload />} role={2} />} />
    {/* Supplementary Nominal Roll */}
    <Route path="/supplementarynominalroll/" element={<ProtectedRoute element={<SupplementaryNominalRoll />} role={2} />} />
    <Route path="/supplementaryfacingsheet/" element={<ProtectedRoute element={<DownloadSupplementaryFacingSheet />} role={2} />} />

    //-----------Credit Application
    <Route path="/principalexternalcreditapplication" element={<ProtectedRoute element={<PrincipalExternalCreditApplication />} role={2} />} />

  </Routes>
);

export default UserRoutes;
